/**
 * @file   src\components\Onboarding\Dashboard\AddProperty.js
 * @brief  This file is responsible for add property section for match
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { pageURLs } from "@/constants";
import { getUserType } from "../../../helpers/common";
import { fetchUserStatistics } from "../../../actions/userprofile";
import { USER_TYPE_AGENT, USER_TYPE_MEMBER } from "../../../constants/common";
import PremiumPlanModal from "../../../components/PlanUpgrade/PremiumPlanModal";
import BasicPlanModal from "../../../components/PlanUpgrade/BasicPlanModal";

const AddProperty = (props) => {
  const { userDetails, selectedClient } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userStatictics = useSelector(
    (state) => state?.userProfile?.userStatictics,
  );
  const userPrivileges = useSelector(
    (state) => state?.userProfile?.userPrivileges,
  );
  const [userCount, setUserCount] = useState({});
  const [allowedCount, setAllowedCount] = useState({});
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const BasicPlanModalClose = () => setBasicPlanModal(false);
  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const [reload, setReload] = useState(0);
  const userType = getUserType();

  const isMember = userType === USER_TYPE_MEMBER;

  useEffect(() => {
    const payload = {
      UserPlanId: userDetails?.User_Plan_Id,
    };

    dispatch(fetchUserStatistics(payload));
  }, [userDetails]);

  useEffect(() => {
    if (userPrivileges !== null && userPrivileges.length > 0) {
      setAllowedCount(userPrivileges[0]);
    } else {
      setAllowedCount({});
    }
  }, [userPrivileges]);

  useEffect(() => {
    if (userStatictics !== null && userStatictics.length > 0) {
      //To fetch user statisctics
      setUserCount(userStatictics[0]);
    } else {
      setUserCount({});
    }
  }, [userStatictics]);

  const updateReloadParam = () => {
    setReload(reload + 1);
  };
  /**
   * To handle add property
   */
  const handleAddProperty = () => {
    if (userCount?.Inventory >= allowedCount?.Inventory) {
      if (userType === USER_TYPE_AGENT) {
        PremiumPlanModalShow();
      } else {
        BasicPlanModalShow();
      }
    } else {
      if (userType === USER_TYPE_AGENT) {
        navigate(pageURLs.agentCreateInventory, {
          state: {
            data: {
              clientId: selectedClient?.value,
              clientName: selectedClient?.label,
              isAgentAsSeller: selectedClient?.AgentAsSeller,
            },
          },
        });
      } else {
        navigate(pageURLs.memberCreateInventory);
      }
    }
  };

  // JAKE-MATCH-REDESIGN: Redesigned empty state CTA cards
  return (
    <>
      {/* JAKE-FUNNEL: Unified "Gauge Real-Time Demand" CTA for member and agent */}
      <div className="match-cta-glow">
        <div className="match-cta-glow__inner">
          <h3 className="match-cta-glow__heading">Gauge Real-Time Demand</h3>
          <p className="match-cta-glow__body">
            {isMember
              ? "Add your property to see real-time buyer demand and get market intelligence. Properties stay completely private."
              : "Add your client's property to see real-time buyer demand. Properties stay completely private until you choose to share them."}
          </p>
          <button
            className="btn btn-primary match-cta-glow__btn"
            onClick={() => handleAddProperty()}
          >
            Add Property
          </button>
        </div>
      </div>
      <PremiumPlanModal
        userDetails={userDetails}
        updateReloadParam={updateReloadParam}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        fromInventoryListing={true}
        showPlanModal={PremiumPlanModalShow}
      />
      <BasicPlanModal
        userDetails={userDetails}
        show={showBasicPlanModal}
        updateReloadParam={updateReloadParam}
        onHide={BasicPlanModalClose}
        fromInventoryListing={true}
        showPlanModal={BasicPlanModalShow}
      />
    </>
  );
};

export default AddProperty;
